import { useEffect } from 'react';

import plusFill from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';

import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// material
import { Button, Container, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

//
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { DeviceForm } from '../components/device';
import { useTranslation } from '../common/LocalizationProvider';
import { selectDevicesArray } from '../createSelectorUtils';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function EditDevice() {
  const t = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const device = useSelector(selectDevicesArray).find(
    (item) => item.id === (location.state !== null ? location.state.id : 0)
  );
  useEffect(() => {
    if (location.state === null || device === undefined) navigate('/device', { replace: true });
  }, [device, location.state, navigate]);

  return (
    <Page title="Edit Device | Click and Take off">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('DeviceEdit_Title')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/device', { replace: true })}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <DeviceForm
              deviceId={location.state !== null ? location.state.id : 0}
              device={device}
            />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
